"use client"

import { usePathname } from "next/navigation"
import clsx from "clsx"

import { useGetCustomer } from "@unlikelystudio/react-ecommerce-hooks"

import InlineCta from "~/components/ui/InlineCta"
import LoginPanel from "~/components/ui/Panels/Login"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { usePanel } from "~/managers/PanelManager"

import * as css from "./styles.css"

export function LoginBanner() {
  const { data: customer, isLoading } = useGetCustomer()

  const { add } = usePanel()
  const pathname = usePathname()
  const t = useTranslate()

  if (!customer || isLoading)
    return (
      <div className={clsx(css.LoginBanner)}>
        <div className={css.content}>
          <span className={css.bannerText}>{t("login_banner_text")}</span>
          <InlineCta
            className={css.cta}
            withDefaultLine
            weight="medium"
            withLine
            onClick={() => add(<LoginPanel returnTo={pathname} />)}
            aria-label={t("account_log_in")}
          >
            {t("account_log_in")}
          </InlineCta>
        </div>
      </div>
    )
  return <></>
}
